import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumBottleDepositBalanceChangeReason implements BaseEnumType {
  private static allValues: EnumBottleDepositBalanceChangeReason[] = []; // make sure this is top-most
  
  public static none = new EnumBottleDepositBalanceChangeReason(0, "None", "enum_bottle_deposit_balance_change_reason_none");
  public static manual = new EnumBottleDepositBalanceChangeReason(1, "Manual", "enum_bottle_deposit_balance_change_reason_manual");
  public static return = new EnumBottleDepositBalanceChangeReason(2, "Return", "enum_bottle_deposit_balance_change_reason_return");
  public static redemption = new EnumBottleDepositBalanceChangeReason(3, "Redemption", "enum_bottle_deposit_balance_change_reason_redemption");
  public static credit = new EnumBottleDepositBalanceChangeReason(4, "Credit", "enum_bottle_deposit_balance_change_reason_credit");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumBottleDepositBalanceChangeReason.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumBottleDepositBalanceChangeReason.none; }
  public isManual() { return this === EnumBottleDepositBalanceChangeReason.manual; }
  public isReturn() { return this === EnumBottleDepositBalanceChangeReason.return; }
  public isRedemption() { return this === EnumBottleDepositBalanceChangeReason.redemption; }
  public isCredit() { return this === EnumBottleDepositBalanceChangeReason.credit; }

  public static getValues(): readonly EnumBottleDepositBalanceChangeReason[] {
    return EnumBottleDepositBalanceChangeReason.allValues;
  }

  public static getValuesExcept0(): readonly EnumBottleDepositBalanceChangeReason[] {
    return EnumBottleDepositBalanceChangeReason.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumBottleDepositBalanceChangeReason {
    const found = EnumBottleDepositBalanceChangeReason.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumBottleDepositBalanceChangeReason - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumBottleDepositBalanceChangeReason): EnumBottleDepositBalanceChangeReason {
    const found = name ? EnumBottleDepositBalanceChangeReason.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumBottleDepositBalanceChangeReason - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumBottleDepositBalanceChangeReason>): boolean {
    return this.key === other?.key;
  }
}